import React from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const Notification = ({ type = 'success', message, onClose }) => {
  const config = {
    success: {
      icon: CheckCircle,
      bgColor: '#d4edda',
      borderColor: '#c3e6cb',
      textColor: '#155724',
      iconColor: '#28a745'
    },
    error: {
      icon: XCircle,
      bgColor: '#f8d7da',
      borderColor: '#f5c6cb',
      textColor: '#721c24',
      iconColor: '#dc3545'
    },
    warning: {
      icon: AlertCircle,
      bgColor: '#fff3cd',
      borderColor: '#ffeeba',
      textColor: '#856404',
      iconColor: '#ffc107'
    },
    info: {
      icon: AlertCircle,
      bgColor: '#d1ecf1',
      borderColor: '#bee5eb',
      textColor: '#0c5460',
      iconColor: '#17a2b8'
    }
  };

  const { icon: Icon, bgColor, borderColor, textColor, iconColor } = config[type];

  return (
    <div style={{
      position: 'fixed',
      top: '2rem',
      right: '2rem',
      zIndex: 9999,
      backgroundColor: bgColor,
      border: `2px solid ${borderColor}`,
      borderRadius: '12px',
      padding: '1.25rem',
      minWidth: '320px',
      maxWidth: '500px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      animation: 'slideInRight 0.3s ease-out'
    }}>
      <div style={{ display: 'flex', alignItems: 'start', gap: '1rem' }}>
        <Icon size={24} style={{ color: iconColor, flexShrink: 0, marginTop: '2px' }} />
        <p style={{ 
          flex: 1,
          fontSize: '1rem',
          color: textColor,
          margin: 0,
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0',
            color: textColor,
            opacity: 0.6,
            transition: 'opacity 0.2s',
            flexShrink: 0
          }}
          onMouseEnter={(e) => e.target.style.opacity = '1'}
          onMouseLeave={(e) => e.target.style.opacity = '0.6'}
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default Notification;
